import { render, staticRenderFns } from "./SendDashReportForm.vue?vue&type=template&id=128e8552"
import script from "./SendDashReportForm.vue?vue&type=script&lang=js"
export * from "./SendDashReportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports